import classNames from 'classnames'
import { format } from 'date-fns'
import { forwardRef } from 'react'
import { Button, ButtonIconPosition, Icon } from '@opallabs/lapidary'
import { DatePickerStyleSelectors, DatePickerStyleStates } from './styles'
import type { DisplayProps } from './types'

export const ButtonDisplay = forwardRef<HTMLButtonElement, DisplayProps>(
  (
    {
      ariaLabel,
      ariaLive,
      buttonCss,
      buttonText,
      buttonVariant,
      className,
      dateDisplayFormat,
      disabled,
      htmlId,
      iconPosition = ButtonIconPosition.trailing,
      open,
      placeholder,
      selectedDate,
      showButtonText,
      ...radixPopoverProps
    },
    ref
  ) => (
    <Button
      ariaLabel={ariaLabel}
      ariaLive={ariaLive}
      buttonText={
        showButtonText
          ? (buttonText ??
            (selectedDate
              ? format(selectedDate, dateDisplayFormat)
              : placeholder))
          : undefined
      }
      id={htmlId}
      name="date-picker"
      styleOverrides={{ button: buttonCss }}
      ref={ref}
      className={classNames([
        DatePickerStyleSelectors.root,
        className,
        { [DatePickerStyleStates.hasValue]: Boolean(selectedDate) },
      ])}
      disabled={disabled}
      icon={<Icon glyph="gem-calendar" />}
      iconPosition={iconPosition}
      variant={open ? 'ghostBlue' : buttonVariant}
      {...radixPopoverProps}
    />
  )
)

ButtonDisplay.displayName = 'Satellite: DatePicker ← ButtonDisplay'
